module.exports = __webpack_public_path__ + "media/assets/icons/talk-bubbles-outline-9a1156d84dfe8d64aa0ca8a758193474.png";